<template>
  <div>
    <div class="w-100">
      <p class="mb-0">Midias na Biblioteca</p>
      <input type="text" class="form-control form-control-sm" placeholder="Buscar..." v-model="filter" @keyup="loadLibrary()" />
      <div class="library-items">
        <medias v-for="item in items.data" :item="item" :key="item.id" @reload="loadLibrary"/>
        <pagination :data="items" :limit="2" size="small" @pagination-change-page="loadLibrary"></pagination>
      </div>
    </div>

    <div class="w-100 text-center border pt-2 rounded" @drop.prevent="addFileDrop" @dragover.prevent>
      <i class="fa fa-upload" @drop.prevent></i>
      <br @drop.prevent>
      <p  @drop.prevent><small>Arraste os arquivos aqui para fazer o upload!</small></p>
    </div>
    <label for="upload-files" class="w-100 clickable text-center"><small>OU CLIQUE AQUI</small></label>
    <item-upload class="bg-white" v-for="item,i in uploadingFiles" :key="i" :file="item" @finished="loadLibrary" />
    <input class="collapse" type="file" id="upload-files" name="upload-files" ref="files" multiple @change="uploadFilesPC">
  </div>
</template>

<script>
import Axios from 'axios'
import ItemUpload from './../../../../Media/Upload'
import Medias from './Medias'
import { mapGetters } from 'vuex'

export default {
  components: {
    "item-upload": ItemUpload,
    "medias": Medias,
  },
  props: {
    // token: {
    //   required: true
    // },
  },
  data () {
    return {
      uploadingFiles: [],
      items: {},
      filter: "",
    }
  },
  methods: {
    uploadFilesPC: function () {
      let files = this.$refs.files.files
      this.uploadingFiles.push(...files)
    },

    addFileDrop(e) {
      let files = e.dataTransfer.files;
      if(!files) return;
      this.uploadingFiles.push(...files)
    },

    loadLibrary: function (page=1) {
      // this.uploadingFiles = this.uploadingFiles.filter( i => {
      //   return i.name != item.name
      // })
      Axios.get(`/teacher/library/${ this.currentUser.id }/items?page=${page}`, {
        params: {
          name: this.filter
        }
      })
        .then( res => {
          this.items = res.data
        })
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser"
    })
  },
  mounted () {
    this.loadLibrary()
  }
}
</script>
